import { NgModule } from '@angular/core';
import { RetainDuringDateChangeDirective } from './directives/retain-during-date-change.directive';
import { CommonModule, DatePipe } from '@angular/common';
import { CommentComponent } from './components/comment/comment.component';
import { IonicPageModule } from 'ionic-angular';
import { ErrorsComponent } from './components/errors/errors.component';
import { DailyLogDatePickerComponent } from './components/daily-log-date-picker/daily-log-date-picker';
import { DailyLogSummaryHeaderComponent } from './components/daily-log-summary-header/daily-log-summary-header';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { TimeZoneService } from '../../services/time-zone/time-zone.service';
import { FormsModule } from '@angular/forms';
import { FoundationModule } from '../../_foundation/foundation.module';
import { WarningModalComponent } from './components/warning-modal/warning-modal.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { LuxonDateAdapter, MAT_LUXON_DATE_FORMATS } from './components/pt-luxon-date-picker/LuxonDateAdapter';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialModule } from '../../material-module';
import { PtLuxonDatePickerComponent } from './components/pt-luxon-date-picker/pt-luxon-date-picker';
import { PtDateTimeCombinedInputComponent } from './components/pt-date-time-combined-input/pt-date-time-combined-input';
import { PtTimeInputComponent } from './components/pt-time-input/pt-time-input';
import { TextMaskModule } from 'angular2-text-mask';
import { PipesModule } from '../../pipes/pipes.module';
import { PtOffsetPickerComponent } from './components/pt-offset-picker/pt-offset-picker';
import { AlertContainerComponent } from './components/alert-container/alert-container';

@NgModule({
  imports: [
    CommonModule,
    IonicPageModule.forChild(CommentComponent),
    IonicPageModule.forChild(ErrorsComponent),
    IonicPageModule.forChild(DailyLogDatePickerComponent),
    IonicPageModule.forChild(WarningModalComponent),
    DatePickerModule,
    FormsModule,
    FoundationModule,
    MaterialModule,
    MatFormFieldModule,
    TextMaskModule,
    PipesModule,
  ],
  declarations: [
    RetainDuringDateChangeDirective,
    DailyLogSummaryHeaderComponent,
    CommentComponent,
    ErrorsComponent,
    DailyLogDatePickerComponent,
    PtOffsetPickerComponent,
    WarningModalComponent,
    PtLuxonDatePickerComponent,
    PtTimeInputComponent,
    PtDateTimeCombinedInputComponent,
    AlertContainerComponent
  ],
  exports: [
    RetainDuringDateChangeDirective,
    DailyLogSummaryHeaderComponent,
    CommentComponent,
    ErrorsComponent,
    DailyLogDatePickerComponent,
    PtOffsetPickerComponent,
    WarningModalComponent,
    PtLuxonDatePickerComponent,
    PtTimeInputComponent,
    PtDateTimeCombinedInputComponent,
    AlertContainerComponent
  ],
  providers: [
    DatePipe,
    TimeZoneService,
    {provide: DateAdapter, useClass: LuxonDateAdapter},
    {provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS},
  ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/pages/shared/shared.module.ts